export const isValidEmail = (email: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

export const validateEmailField = (email: string): string => {
  if (!email) return "Email is required";
  if (!isValidEmail(email)) return "Enter a valid email";
  return "";
};

export const validatePhone = (phone: string): string => {
  if (!phone) return "Phone is required";
  if (!/^[0-9]{10}$/.test(phone)) {
    return "Enter valid 10-digit phone";
  }
  return "";
};